// import React, { useState } from 'react'
// import HeaderTwoTop from './HeaderTwoTop'
// import mainLogo from '../../assets/img/Shreegita.png';
// import { Link } from 'react-router-dom';
// import MobileMenu from './MobileMenu';

// const HeaderTwo = () => {
//     const [search, setSearch] = useState(true);
//     const [mobileMenu, setMobileMenu] = useState(true);

//     const handleSearch = () => {
//         setSearch(!search);
//     }

//     const handleMobileMenu = () => {
//         setMobileMenu(!mobileMenu);
//       }

//   return (
//     <header className="header-wrap header-2">
//        <HeaderTwoTop/>
//         <div className="main-header-wrapper">
//             <div className="container-fluid align-items-center justify-content-between d-flex p-0" >
//                 <div className="logo">
//                     <Link to="/"><img src={mainLogo} alt="logo"/></Link>
//                 </div>
//                 <div className="main-menu d-none d-lg-block">
//                     <ul>
//                     {/* <i className="fal fa-plus"></i> */}
//                         <li><Link to="/">Home </Link>
//                             {/* <ul className="sub-menu">
//                                 <li><Link to="/">homepage 1</Link></li>
//                                 <li><Link to="/homeTwo">homepage 2</Link></li>
//                                 <li><Link to="/homeThree">homepage 3</Link></li>
//                                 <li><Link to="/homeFour">homepage 4</Link></li>
//                                 history
//                             </ul> */}
//                         </li>
//                         <li><Link to="/about">about  <i className="fal fa-plus"></i></Link>
                        
//                         <ul className="sub-menu">
//                                 <li><Link to="/history">History</Link></li>
//                                 <li><Link to="/misson_vision">Misson & Vision</Link></li>
//                                 <li><Link to="/Corporate_Value">Corporate Value</Link></li>
//                                 {/* <li><Link to="/warehouse">Gold Coin Warehousing  </Link></li> */}
//                                 {/* <li><Link to="/Clients">Our Clients      </Link></li> */}
                             
                               
//                             </ul>  
//                         </li>
//                         <li><Link to="/warehouse">    Warehousing  </Link>  </li>
//                         <li><Link to="/companyprofile">Company Profile <i className="fal fa-plus"></i></Link>
//                            <ul className="sub-menu" style={{
//                             width:"300px"
//                         }}  >
//                                 <li><Link to="/Chairmain">Chairmain Message</Link></li>
//                                 <li><Link to="/Management">Management</Link></li>
//                                 <li><Link to="/acc_nd_rec">Accreditation & Recognition</Link></li>
//                                 <li><Link to="/Memberships">Memberships</Link></li>
//                             </ul>  
//                         </li>
//                         <li><Link to="/products">Our Products  <i className="fal fa-plus"></i></Link>
//                         <ul className="sub-menu" style={{
//                             width:"300px"
//                         }}>
//                                 <li><Link to="/raw_cotton">Raw Cotton</Link></li>
//                                 <li><Link to="/ConsumerEdibleOils">Consumer Edible Oils
//                                 </Link></li>
//                                 <li><Link to="/CommercialOils">Commercial Oils</Link></li>
//                                 <li><Link to="/OilCakes">Oil Cakes (Cattle Feeds)</Link></li>
//                                 <li><Link to="/OilMeals">Oil Meals (Solvent Extracted De-Oiled Cakes)</Link></li>
//                                 <li><Link to="/Seeds">Oil seeds / Grains / Pulses</Link></li>
//                                 <li><Link to="/CottonYarns">Cotton Yarns</Link></li>
                               
//                             </ul> 
//                         </li>
//                         <li><Link to="/Inquiry">Inquiry</Link></li>
//                         <li><Link to="/Gallery">Gallery</Link></li>
//                         <li><Link to="/contact">Contact</Link></li>
//                         <li><Link to="/blogs">Blogs</Link></li>
//                     </ul>
//                 </div>
//                 <div className="d-inline-block d-lg-none">
//                     <div className="mobile-nav-wrap">                    
//                         <div id="hamburger" onClick={handleMobileMenu}>
//                             <i className="fal fa-bars"></i>
//                         </div>
//                        <MobileMenu mobileMenu={mobileMenu} handleMobileMenu={handleMobileMenu} />
//                     </div>
//                     <div className="overlay"></div>
//                 </div>
//                 {/* <div className="right-elements d-none d-xl-flex d-flex align-items-center">
//                         <div className="search-icon">
//                         <span className="search-btn" onClick={handleSearch} style={{cursor: 'pointer'}}><i className="fas fa-search"></i></span>
//                         <div className={search ? 'search-box' : 'search-box show'}>
//                             <form action="#">
//                                 <input type="text" placeholder="Search"/>
//                                 <button type="submit"><i className="fal fa-search"></i></button>
//                             </form>
//                         </div>
//                     </div>   
//                     <div className="call-action">
//                         <span>Call For Support</span>
//                         <p>+5 282 350 360</p>
//                     </div>
//                 </div> */}
//             </div>
//         </div>
//     </header>
//   )
// }

// export default HeaderTwo

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import HeaderTwoTop from './HeaderTwoTop';
import MobileMenu from './MobileMenu';
import mainLogo from '../../assets/img/Shreegita.png';

const HeaderTwo = () => {
  const [search, setSearch] = useState(true);
  const [mobileMenu, setMobileMenu] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1320);

  const handleSearch = () => setSearch(!search);
  const handleMobileMenu = () => setMobileMenu(!mobileMenu);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1320);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <header className="header-wrap header-2">
      <HeaderTwoTop />

      <div className="main-header-wrapper">
        <div className="container-fluid d-flex align-items-center justify-content-between p-0">
          {/* Logo */}
          <div className="logo">
            <Link to="/"><img src={mainLogo} alt="logo" /></Link>
          </div>

          {/* Conditional Menus */}
          {isMobile ? (
            // Mobile Menu
            <div className="d-inline-block">
              <div className="mobile-nav-wrap">
                <div id="hamburger" onClick={handleMobileMenu}>
                  <i className="fal fa-bars"></i>
                </div>
                <MobileMenu mobileMenu={mobileMenu} handleMobileMenu={handleMobileMenu} />
              </div>
              <div className="overlay"></div>
            </div>
          ) : (
            // Desktop Menu
            <div className="main-menu">
              <ul>
                <li><Link to="/">Home</Link></li>
                <li>
                  <Link to="/about">About <i className="fal fa-plus"></i></Link>
                  <ul className="sub-menu">
                    <li><Link to="/history">History</Link></li>
                    <li><Link to="/misson_vision">Mission & Vision</Link></li>
                    <li><Link to="/Corporate_Value">Corporate Value</Link></li>
                  </ul>
                </li>
                <li><Link to="/warehouse">Warehousing</Link></li>
                <li>
                  <Link to="/companyprofile">Company Profile <i className="fal fa-plus"></i></Link>
                  <ul className="sub-menu" style={{ width: "300px" }}>
                    <li><Link to="/Chairmain">Chairman Message</Link></li>
                    <li><Link to="/Management">Management</Link></li>
                    <li><Link to="/acc_nd_rec">Accreditation & Recognition</Link></li>
                    {/* <li><Link to="/Memberships">Memberships</Link></li> */}
                  </ul>
                </li>
                <li>
                  <Link to="/products">Our Products <i className="fal fa-plus"></i></Link>
                  <ul className="sub-menu" style={{ width: "300px" }}>
                    <li><Link to="/raw_cotton">Raw Cotton</Link></li>
                    <li><Link to="/ConsumerEdibleOils">Consumer Edible Oils</Link></li>
                    <li><Link to="/CommercialOils">Commercial Oils</Link></li>
                    <li><Link to="/OilCakes">Oil Cakes (Cattle Feeds)</Link></li>
                    <li><Link to="/OilMeals">Oil Meals</Link></li>
                    <li><Link to="/Seeds">Seeds / Pulses</Link></li>
                    <li><Link to="/CottonYarns">Cotton Yarns</Link></li>
                  </ul>
                </li>
                <li><Link to="/Inquiry">Inquiry</Link></li>
                {/* <li><Link to="/Gallery">Gallery</Link></li> */}
                <li><Link to="/contact">Contact</Link></li>
                {/* <li><Link to="/blogs">Blogs</Link></li> */}
                <li><Link to="/Outlet">Factory Outlets</Link></li>
              </ul>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default HeaderTwo;
